import React from 'react'
import XCancel from './XCancel'
import { usePost } from '../context/PostContext'
import { MdPeople } from 'react-icons/md';
import Image02 from "../assets/profile.svg";
import { BsFillPersonCheckFill } from 'react-icons/bs';

export default function MyConnections({ close }) {

    const { myConnections, taggedConnections, setTaggedConnections } = usePost();
    
    const userHasBeenTagged = (data) => {
        const queryTaggedUsers = taggedConnections.find((user) => user?.userId === data?.userId)
        return queryTaggedUsers;
    }
    
    const tagUser = (data) => {
        if(userHasBeenTagged(data)){
            setTaggedConnections((prev) => prev.filter((user) => user?.userId !== data?.userId))
        }else{
            setTaggedConnections((prev) => [...prev, data])
        }
    }
    
    return (
        <>
            <div className="px-[20px] pb-[32px] w-[300px] md:w-[536px] h-[auto] relative">
                <span className='absolute p-0 m-0 z-40 -top-3 -right-3'>
                    <XCancel close={close} />
                </span>
                <div className="w-full h-full flex flex-col justify-center py-6">
                    <div className="flex items-center justify-start pb-8 gap-2">
                        <MdPeople className="text-zxl text-primary" />
                        <h4 className="text-sm font-semibold">My Connections</h4>
                    </div>
                    <div className="max-h-80 pb-4 overflow-y-scroll">
                        {myConnections?.length > 0 ? myConnections?.map((member) => {
                            return <div onClick={() => tagUser(member)} key={myConnections?.indexOf(member)} className={`flex px-3 justify-between py-2 border-b cursor-pointer hover:bg-gray-200 items-center gap-2 ${myConnections?.indexOf(member) !== myConnections?.length - 1 && 'border-gray-400'}`}>
                               <div className="flex gap-4 items-center">
                                    <img alt='' className="w-14 h-14 rounded-full" src={member.profilePicture || Image02} />
                                    <div>
                                        <h4 className='text-sm font-semibold'>{member?.firstName + " " + member?.lastName}</h4>
                                        <p className='text-xs'>{`${member?.city}, ${member?.state}`}</p>
                                    </div>
                               </div>
                                {userHasBeenTagged(member) && <div>
                                    <BsFillPersonCheckFill className="text-xl" />
                                </div>}
                            </div>;
                        }) :
                            <div className='mt-4 h-40 pb-4 text-center flex flex-col items-center justify-center'>
                                <h4 className="text-sm font-semibold">No Connections Yet</h4>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
